import Vue from 'vue';
import collectjs from 'collect.js';
import moment from 'moment-timezone';
import 'moment/locale/id'

if (process.browser) {
  const $toast = require('~/utils/toast').default;
  const $snackbar = require('~/utils/snackbar').default;

  global.toast = $toast;
  global.snackbar = $snackbar;
}

// MOMENT
moment.tz.setDefault("Asia/Jakarta");
moment.defineLocale('id', {
  months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
  monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
  monthsParseExact : true,
  weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
  weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab.'.split('_'),
  weekdaysMin : 'Mi_Se_Se_Ra_Ka_Ju_Sa'.split('_'),
  weekdaysParseExact : true,
});
global.moment = moment;

global.Vue = Vue;

global.collect = collectjs;

global.helpers = require('~/utils/helpers').default;

global.trans = require('~/utils/trans').default;
